import { Cell, Legend, Pie, PieChart, ResponsiveContainer, Tooltip } from 'recharts';
import { categoricalColor, CHART_TOOLTIP_STYLE, statusColor } from '@/lib/chartPalette';

export function StatusPieChart({
  data,
  nameKey,
  valueKey,
  variant = 'categorical',
}: {
  data: Array<Record<string, unknown>>;
  nameKey: string;
  valueKey: string;
  variant?: 'categorical' | 'status';
}) {
  return (
    <ResponsiveContainer width="100%" height={260}>
      <PieChart>
        <Pie data={data} dataKey={valueKey} nameKey={nameKey} innerRadius={55} outerRadius={90} paddingAngle={2}>
          {data.map((row, index) => (
            <Cell
              key={index}
              fill={variant === 'status' ? statusColor(String(row[nameKey])) : categoricalColor(index)}
              stroke="hsl(var(--card))"
              strokeWidth={2}
            />
          ))}
        </Pie>
        <Tooltip contentStyle={CHART_TOOLTIP_STYLE} />
        {/*
          itemSorter={null} keeps the legend in slice order. Recharts v3 defaults
          it to 'value' (alphabetical by label), which v2 did not do. Callers
          pass rows already ordered on purpose (sortStatusRows by severity,
          foldToOther by value with "Other" last) and slices take their hue from
          that row index, so an alphabetised legend would no longer follow the
          slices or leave the "Other" bucket last.
        */}
        <Legend iconType="circle" iconSize={8} itemSorter={null} />
      </PieChart>
    </ResponsiveContainer>
  );
}
